import { render, staticRenderFns } from "./70.vue?vue&type=template&id=11a53ca6&scoped=true&"
var script = {}
import style0 from "./70.vue?vue&type=style&index=0&id=11a53ca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a53ca6",
  null
  
)

export default component.exports